import React from "react";
import PropTypes from "prop-types";

function DashboardTextCard({
  type,
  prelineLeft,
  prelineRight,
  midlineLeft,
  midlineRight,
  headlineLeft,
  headlineRight,
}) {
  if (type === "primary") {
    return (
      <div className="card card-primary card-dashboard-text">
        <div className="card-body">
          <div className="card-content">
            <div className="card-headline-wrapper">
              <h5
                className="card-headline text-tertiary"
                dangerouslySetInnerHTML={{ __html: headlineLeft }}
              />
              <h5
                className="card-headline text-tertiary"
                dangerouslySetInnerHTML={{ __html: headlineRight }}
              />
            </div>
            <div className="card-headline-wrapper">
              <b
                className="card-headline text-primary"
                dangerouslySetInnerHTML={{ __html: midlineLeft }}
              />
              <b
                className="card-headline text-primary"
                dangerouslySetInnerHTML={{ __html: midlineRight }}
              />
            </div>
            <div className="card-preline-wrapper">
              <div
                className="card-preline text-primary"
                dangerouslySetInnerHTML={{ __html: prelineLeft }}
              />
              <div
                className="card-preline text-primary"
                dangerouslySetInnerHTML={{ __html: prelineRight }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card card-tertiary card-dashboard-text">
      <div className="card-body">
        <div className="card-content">
          <div className="card-headline-wrapper">
            <h5
              className="card-headline text-primary"
              dangerouslySetInnerHTML={{ __html: headlineLeft }}
            />
            <h5
              className="card-headline text-primary"
              dangerouslySetInnerHTML={{ __html: headlineRight }}
            />
          </div>
          <div className="card-headline-wrapper">
            <b className="card-headline" dangerouslySetInnerHTML={{ __html: midlineLeft }} />
            <b className="card-headline" dangerouslySetInnerHTML={{ __html: midlineRight }} />
          </div>
          <div className="card-preline-wrapper">
            <div className="card-preline" dangerouslySetInnerHTML={{ __html: prelineLeft }} />
            <div className="card-preline" dangerouslySetInnerHTML={{ __html: prelineRight }} />
          </div>
        </div>
      </div>
    </div>
  );
}

DashboardTextCard.propTypes = {
  type: PropTypes.string,
  prelineLeft: PropTypes.string,
  prelineRight: PropTypes.string,
  midlineLeft: PropTypes.string,
  midlineRight: PropTypes.string,
  headlineLeft: PropTypes.string,
  headlineRight: PropTypes.string,
};

export default DashboardTextCard;
